// ==============================|| OVERRIDES - AUTOCOMPLETE ||============================== //

export default function Autocomplete() {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            padding: '0 8px',
            fontWeight: 600,
            minWidth: '124px',
          },
        },
        popupIndicator: {
          width: 'auto',
          height: 'auto',
        },
        clearIndicator: {
          width: 'auto',
          height: 'auto',
        },
        popper: {
          '& .MuiPaper-root': {
            borderRadius: '8px!important',
            border: '0!important',
            boxShadow:
              '0px 4px 6px -2px rgba(16, 24, 40, 0.03),0px 12px 16px -4px rgba(16, 24, 40, 0.08)!important',
          },
          '& .MuiAutocomplete-listbox': {
            padding: '0!important',
          },
        },
        option: {
          padding: '12px 16px!important',
          fontWeight: 400,
        },
      },
    },
  }
}
